import React from "react";
import CSVReader from 'react-csv-reader'
import { CSVLink } from 'react-csv'
import { Table, Tag, Button, Spin, Typography,Icon, message, Popover } from 'antd'
import { API, Auth } from "aws-amplify"
import BaseAdmin from '../AdminPanel/BaseAdmin'

import "../../Styles/Services/checkInvoiceCSV.css"

class CheckInvoicesCSV extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            csv: []
        }
    }

    procesarFacturas() {
        Auth.currentSession()
            .then(session => {
                this.state.csv.forEach((value, index) => {
                    if (value.estado === "Sin procesar") {
                        let csv = this.state.csv
                        csv[index]["estado"] = "Procesando"
                        this.setState({ csv: csv })

                        API.get(
                            'test',
                            '/root/invoices/afip/check',
                            {
                                headers: {
                                    Authorization: session.getIdToken().getJwtToken()
                                },
                                queryStringParameters: {
                                    cbte_modo: value.modalidad_de_autorizacion,
                                    cbte_nro: value.numero_de_comprobante,
                                    cbte_tipo: parseInt(value.tipo_comprobante),
                                    cod_autorizacion: value.codigo_autorizacion,
                                    cuit_emisor: value.cuit_emisor,
                                    doc_nro_receptor: value.numero_documento_receptor,
                                    doc_tipo_receptor: parseInt(value.tipo_documento_receptor),
                                    cbte_fch: value.fecha_de_comprobante,
                                    imp_total: value.importe_total,
                                    pto_vta: value.punto_de_venta
                                }
                            }
                        )
                            .then(response => {
                                if (response.resultado === "A") {
                                    let csv = this.state.csv
                                    csv[index]["estado"] = "Correcta"
                                    this.setState({ csv: csv })
                                }
                                else {
                                    let csv = this.state.csv
                                    csv[index]["estado"] = "Incorrecta"
                                    csv[index]["errores"] = response.observaciones
                                    csv[index]["errores_printable"] = response.observaciones.reduce((acc, curr) => {return acc + curr.msg + ", "}, "")
                                    this.setState({ csv: csv })
                                }
                            })
                            .catch(err => {
                                message.error("Error procesando factura " + this.state.csv[index].numero_de_comprobante)
                                let csv = this.state.csv
                                csv[index]["estado"] = "Sin procesar"
                                this.setState({ csv: csv })
                            })
                    }
                })
            })
    }

    render() {
        let routes = [
            {
                path: "/admin",
                breadcrumbName: <Icon type="home" />
            },
            {
                path: "/verificar-facturas",
                breadcrumbName: "Verificar Facturas"
            }
        ]

        let headers = [
            {
                label: "Numero de comprobante",
                title: "Numero de comprobante",
                key: "numero_de_comprobante",
                dataIndex: "numero_de_comprobante",
                fixed: "left"
            },
            {
                label: "Fecha de comprobante",
                title: "Fecha de comprobante",
                key: "fecha_de_comprobante",
                dataIndex: "fecha_de_comprobante",
            },
            {
                label: "Modalidad de autorizacion",
                title: "Modalidad de autorizacion",
                key: "modalidad_de_autorizacion",
                dataIndex: "modalidad_de_autorizacion",
            },
            {
                label: "CUIT emisor",
                title: "CUIT emisor",
                key: "cuit_emisor",
                dataIndex: "cuit_emisor",
            },
            {
                label: "Tipo comprobante",
                title: "Tipo comprobante",
                key: "tipo_comprobante",
                dataIndex: "tipo_comprobante",
            },
            {
                label: "Punto de venta",
                title: "Punto de venta",
                key: "punto_de_venta",
                dataIndex: "punto_de_venta",
            },

            {
                label: "Importe total",
                title: "Importe total",
                key: "importe_total",
                dataIndex: "importe_total",
            },
            {
                label: "Codigo autorizacion",
                title: "Codigo autorizacion",
                key: "codigo_autorizacion",
                dataIndex: "codigo_autorizacion",
            },
            {
                label: "Tipo documento receptor",
                title: "Tipo documento receptor",
                key: "tipo_documento_receptor",
                dataIndex: "tipo_documento_receptor",
            },
            {
                label: "Numero documento receptor",
                title: "Numero documento receptor",
                key: "numero_documento_receptor",
                dataIndex: "numero_documento_receptor",
            },
            {
                label: "Estado",
                title: "Estado",
                key: "estado",
                dataIndex: "estado",
                render: (value, record) => {
                    switch (value) {
                        case "Sin procesar":
                            return <Tag>Sin procesar</Tag>
                        case "Procesando":
                            return <Spin />
                        case "Correcta":
                            return <Tag color="green">Factura correcta</Tag>
                        case "Incorrecta":
                            return <Popover title="Errores" content={record.errores.map((value, index) => <p key={index}>{value.msg}</p>)}><Tag color="red">Factura incorrecta</Tag></Popover>
                        default:
                            break;
                    }
                },
                fixed: "right",
                filters: [
                    {
                        value: "Sin procesar",
                        text: "Sin procesar"
                    },
                    {
                        value: "Procesando",
                        text: "Procesando"
                    },
                    {
                        value: "Correcta",
                        text: "Correcta"
                    },
                    {
                        value: "Incorrecta",
                        text: "Incorrecta"
                    }
                ],
                filterMultiple: true,
                onFilter: (value, record) => record.estado.indexOf(value) === 0
            },
            {
                label: "Errores",
                key: "errores_printable"
            }
        ]

        let loading = this.state.csv.reduce((acc, curr) => { return acc ? true : curr.estado === "Procesando" }, false)
        let disabledDownload = this.state.csv.length === 0 || this.state.csv.reduce((acc, curr) => { return acc ? true : curr.estado === "Sin procesar" }, false)
        let disabledProcess = (this.state.csv.length === 0 || this.state.csv.reduce((acc, curr) => { return acc ?  curr.estado !== "Sin procesar" : false }, true)) && !loading

        return (
            <BaseAdmin
                selected='verificar-facturas'
                routes={routes}>

                <Typography.Title style={{ textAlign: "center" }}>Validador de facturas con CSV</Typography.Title>
                <div style={{ marginLeft: "15px" }}>
                    <CSVReader
                        onFileLoaded={(data) => {
                            let rows = data.map((value, index) => {
                                value["key"] = index
                                value["estado"] = "Sin procesar"
                                return value
                            })
                            this.setState({ csv: rows })
                        }}
                        parserOptions={{
                            header: true,
                            skipEmptyLines: true,
                            transformHeader: header =>
                                header
                                    .toLowerCase()
                                    .replace(/\W/g, '_')
                        }}
                        cssClass="ant-btn ant-btn-primary"
                        label="Importar CSV"
                    />
                </div>
                <Table
                    columns={headers}
                    dataSource={this.state.csv}
                    scroll={{ x: "max-content" }}
                    style={{ margin: "20px" }}
                />
                <Button.Group style={{ marginTop: "15px", marginLeft: "15px" }}>
                    <Button
                        type="primary"
                        onClick={(e) => this.procesarFacturas()}
                        loading={loading}
                        disabled={disabledProcess}
                    >
                        Procesar facturas
                    </Button>
                    <Button
                        loading={loading}
                        type="primary"
                        disabled={disabledDownload}
                    >
                        <CSVLink
                            data={this.state.csv}
                            headers={headers}
                            filename="Facturas_procesadas.csv"
                            style={{marginLeft:'10px'}}
                        >
                            Descargar resultados
                    </CSVLink>
                    </Button>
                </Button.Group>

            </BaseAdmin>

        )
    }
}

export default CheckInvoicesCSV